// general
import { createApp } from "vue";
import App from "./App.vue";

// pinia
import { createPinia } from "pinia";

// router
import router from "./router";

// styles
import "../node_modules/vue-multiselect/dist/vue-multiselect.css";
import "./styles/styles.css";
import "aos/dist/aos.css";

createApp(App).use(router).use(createPinia()).mount("#app");

//Version
window.version = process.env.BASE_URL.split('/')[3];